import { render, staticRenderFns } from "./SeatSelection.vue?vue&type=template&id=60b77ae8&scoped=true"
import script from "./SeatSelection.vue?vue&type=script&lang=js"
export * from "./SeatSelection.vue?vue&type=script&lang=js"
import style0 from "./SeatSelection.vue?vue&type=style&index=0&id=60b77ae8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b77ae8",
  null
  
)

export default component.exports